"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SquareRootInchOfWaterColumn = exports.SquareRootPascal = void 0;
var uom_1 = require("uom");
exports.SquareRootPascal = uom_1.UnitFormat.createUnitFormat("√Pa", 2);
exports.SquareRootInchOfWaterColumn = uom_1.UnitFormat.createUnitFormat("√in WC", 2); //sqrt(Pa/249.0889) = 0.06335029447
//# sourceMappingURL=square-root-pressure-format.js.map